import { Country, State, City } from "country-state-city";

export function getLocationObject({ countryName, stateName, cityName }) {
  const country = Country.getAllCountries().find((c) => c.name === countryName);
  if (!country) return null;
  const state = State.getStatesOfCountry(country.isoCode).find(
    (s) => s.name === stateName,
  );
  if (!state) return null;
  const city = City.getCitiesOfState(country.isoCode, state.isoCode).find(
    (c) => c.name === cityName,
  );
  if (!city) return null;

  return {
    country: country.name,
    state: state.name,
    city: city.name,
    countryCode: country.isoCode,
    stateCode: state.isoCode,
    cityId: city.id,
    formatted: `${city.name}, ${state.name}, ${country.name}`,
  };
}
